/**
 * Puts [value] on the clipboard, and says whether it got there.
 *
 * Shared by the driver's number to transfer to, and the bank tiles that open on it.
 */
export async function copyText(value: string): Promise<boolean> {
  try {
    // Requires a user gesture and a secure context; both hold here. iOS below 13.4
    // has neither, which is what the fallback is for.
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    const box = document.createElement('textarea');
    box.value = value;
    box.setAttribute('readonly', '');
    box.style.position = 'fixed';
    box.style.opacity = '0';
    document.body.appendChild(box);
    box.select();
    let done = false;
    try {
      done = document.execCommand('copy');
    } catch {
      // Nothing worked. The value is on screen and can be read out loud, which
      // is what most people do with it anyway.
    }
    document.body.removeChild(box);
    return done;
  }
}
